import { SORTING_KEY } from 'constants/general';
import { SORTING, SortingOption, SortOptions } from 'constants/sorting';

export type SortingState = {
  [key in SortOptions]: (typeof SORTING)[key][number]['key'];
};

const savedSorting = JSON.parse(localStorage.getItem(SORTING_KEY) ?? '{}');

// Checks if saved sorting value from localStorage is valid and picks either that, or default one from SORTING object
const getSavedSorting = <Option extends SortOptions>(option: Option): (typeof SORTING)[Option][number]['key'] =>
  (SORTING[option] as unknown as SortingOption[]).find(sort => sort.key === savedSorting?.[option])?.key ??
  SORTING[option][0].key;

export const initialState: SortingState = {
  posts: getSavedSorting(SortOptions.POSTS),
  flaggedPosts: getSavedSorting(SortOptions.FLAGGED_POSTS),
  flaggedComments: getSavedSorting(SortOptions.FLAGGED_COMMENTS),
  comments: getSavedSorting(SortOptions.COMMENTS),
};
